import 'react';
import { useMutation } from '@apollo/client';
import '@apollo/client/react/components';

var SubmitPathNodeFlowDocument = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "SubmitPathNodeFlow"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "input"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "SubmitPathNodeFlowInputCommandsInput"
          }
        }
      }
    }],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "submitPathNodeFlowInputCommands"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "input"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "input"
            }
          }
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "pathGraphFlow"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "FragmentSpread",
                "name": {
                  "kind": "Name",
                  "value": "PathGraphFlow"
                }
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "error"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "FragmentSpread",
                "name": {
                  "kind": "Name",
                  "value": "NavigatePathGraphFlowError"
                }
              }]
            }
          }]
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "PathGraphFlow"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "PathGraphFlow"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "nodes"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "FragmentSpread",
            "name": {
              "kind": "Name",
              "value": "PathNodeFlow"
            }
          }]
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "sourceKey"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "completed"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "requestEvents"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "FragmentSpread",
            "name": {
              "kind": "Name",
              "value": "PathGraphFlowRequestEvent"
            }
          }]
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "runMode"
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "PathNodeFlow"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "PathNodeFlow"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "pathGraphSlug"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "references"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "FragmentSpread",
            "name": {
              "kind": "Name",
              "value": "PathNodeMaterializedReference"
            }
          }]
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "viewModel"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            }
          }, {
            "kind": "InlineFragment",
            "typeCondition": {
              "kind": "NamedType",
              "name": {
                "kind": "Name",
                "value": "InterstitialPathNodeFlowViewModel"
              }
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "slug"
                }
              }, {
                "kind": "FragmentSpread",
                "name": {
                  "kind": "Name",
                  "value": "InterstitialPathNodeFlowViewModel"
                }
              }]
            }
          }, {
            "kind": "InlineFragment",
            "typeCondition": {
              "kind": "NamedType",
              "name": {
                "kind": "Name",
                "value": "QuestionsPathNodeFlowViewModel"
              }
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "slug"
                }
              }, {
                "kind": "FragmentSpread",
                "name": {
                  "kind": "Name",
                  "value": "QuestionsPathNodeFlowViewModel"
                }
              }]
            }
          }, {
            "kind": "FragmentSpread",
            "name": {
              "kind": "Name",
              "value": "CreateAccountPathNodeFlowViewModel"
            }
          }, {
            "kind": "FragmentSpread",
            "name": {
              "kind": "Name",
              "value": "RedirectPathNodeFlowViewModel"
            }
          }, {
            "kind": "FragmentSpread",
            "name": {
              "kind": "Name",
              "value": "DryRunInfoPathNodeFlowViewModel"
            }
          }, {
            "kind": "FragmentSpread",
            "name": {
              "kind": "Name",
              "value": "ErrorPathNodeFlowViewModel"
            }
          }]
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "estimatedPercentCompleted"
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "PathNodeMaterializedReference"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "PathNodeMaterializedReference"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "owningEntityId"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "owningEntityType"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "rootOwner"
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "InterstitialPathNodeFlowViewModel"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "InterstitialPathNodeFlowViewModel"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "slug"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "result"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "InlineFragment",
            "typeCondition": {
              "kind": "NamedType",
              "name": {
                "kind": "Name",
                "value": "ImageBlocksInterstitialPathNodeFlowViewModel"
              }
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "blocks"
                },
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "FragmentSpread",
                    "name": {
                      "kind": "Name",
                      "value": "ImageBlockInterstitialPathNodeFlowViewModel"
                    }
                  }]
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "headerText"
                },
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "FragmentSpread",
                    "name": {
                      "kind": "Name",
                      "value": "PathTextViewModel"
                    }
                  }]
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "subHeaderText"
                },
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "FragmentSpread",
                    "name": {
                      "kind": "Name",
                      "value": "PathTextViewModel"
                    }
                  }]
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "progression"
                },
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "InlineFragment",
                    "typeCondition": {
                      "kind": "NamedType",
                      "name": {
                        "kind": "Name",
                        "value": "ContinueButtonInterstitialProgressionPathNodeFlowViewModel"
                      }
                    },
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "FragmentSpread",
                        "name": {
                          "kind": "Name",
                          "value": "ContinueButtonInterstitialProgressionPathNodeFlowViewModel"
                        }
                      }]
                    }
                  }, {
                    "kind": "InlineFragment",
                    "typeCondition": {
                      "kind": "NamedType",
                      "name": {
                        "kind": "Name",
                        "value": "TimedContinueInterstitialProgressionPathNodeFlowViewModel"
                      }
                    },
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "FragmentSpread",
                        "name": {
                          "kind": "Name",
                          "value": "TimedContinueInterstitialProgressionPathNodeFlowViewModel"
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "ImageBlockInterstitialPathNodeFlowViewModel"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "ImageBlockInterstitialPathNodeFlowViewModel"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "primaryImage"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "FragmentSpread",
            "name": {
              "kind": "Name",
              "value": "PathMediaFile"
            }
          }]
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "subTitleText"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "FragmentSpread",
            "name": {
              "kind": "Name",
              "value": "PathTextViewModel"
            }
          }]
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "titleText"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "FragmentSpread",
            "name": {
              "kind": "Name",
              "value": "PathTextViewModel"
            }
          }]
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "PathMediaFile"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "MediaFile"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "url"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "mimeType"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "size"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "persisted"
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "PathTextViewModel"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "PathTextViewModel"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "plainText"
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "ContinueButtonInterstitialProgressionPathNodeFlowViewModel"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "ContinueButtonInterstitialProgressionPathNodeFlowViewModel"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "continueButtonText"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "FragmentSpread",
            "name": {
              "kind": "Name",
              "value": "PathTextViewModel"
            }
          }]
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "TimedContinueInterstitialProgressionPathNodeFlowViewModel"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "TimedContinueInterstitialProgressionPathNodeFlowViewModel"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "continueInMilliseconds"
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "QuestionsPathNodeFlowViewModel"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "QuestionsPathNodeFlowViewModel"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "skipButtonText"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "FragmentSpread",
            "name": {
              "kind": "Name",
              "value": "PathTextViewModel"
            }
          }]
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "submitButtonText"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "FragmentSpread",
            "name": {
              "kind": "Name",
              "value": "PathTextViewModel"
            }
          }]
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "questionsDisplayComponents"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "FragmentSpread",
            "name": {
              "kind": "Name",
              "value": "QuestionsDisplayComponentPathNodeFlowViewModel"
            }
          }]
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "questions"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "FragmentSpread",
            "name": {
              "kind": "Name",
              "value": "QuestionPathNodeFlowViewModel"
            }
          }]
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "QuestionsDisplayComponentPathNodeFlowViewModel"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "QuestionsDisplayComponentPathNodeFlowViewModel"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "InlineFragment",
        "typeCondition": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "QuestionsDisplayComponentPathNodeFlowViewModel"
          }
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "displayComponentType"
            }
          }]
        }
      }, {
        "kind": "InlineFragment",
        "typeCondition": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "TcpaComplianceQuestionsDisplayComponentPathNodeFlowViewModel"
          }
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "displayComponentType"
            }
          }]
        }
      }, {
        "kind": "InlineFragment",
        "typeCondition": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "TermsAndConditionsQuestionsDisplayComponentPathNodeFlowViewModel"
          }
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "displayComponentType"
            }
          }]
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "QuestionPathNodeFlowViewModel"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "QuestionPathNodeFlowViewModel"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "commonFields"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "inputLabel"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "FragmentSpread",
                "name": {
                  "kind": "Name",
                  "value": "PathTextViewModel"
                }
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "questionSubText"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "FragmentSpread",
                "name": {
                  "kind": "Name",
                  "value": "PathTextViewModel"
                }
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "questionText"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "FragmentSpread",
                "name": {
                  "kind": "Name",
                  "value": "PathTextViewModel"
                }
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "required"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "validationErrors"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "FragmentSpread",
                "name": {
                  "kind": "Name",
                  "value": "QuestionPathNodeFlowViewModelValidationError"
                }
              }]
            }
          }]
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "schemaType"
        }
      }, {
        "kind": "FragmentSpread",
        "name": {
          "kind": "Name",
          "value": "DateQuestionPathNodeFlowViewModel"
        }
      }, {
        "kind": "FragmentSpread",
        "name": {
          "kind": "Name",
          "value": "InputTextQuestionPathNodeFlowViewModel"
        }
      }, {
        "kind": "FragmentSpread",
        "name": {
          "kind": "Name",
          "value": "ListQuestionPathNodeFlowViewModel"
        }
      }, {
        "kind": "FragmentSpread",
        "name": {
          "kind": "Name",
          "value": "NumericQuestionPathNodeFlowViewModel"
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "QuestionPathNodeFlowViewModelValidationError"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "QuestionPathNodeFlowViewModelValidationError"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "InlineFragment",
        "typeCondition": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "ErrorMessage"
          }
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "errorMessage"
            }
          }]
        }
      }, {
        "kind": "InlineFragment",
        "typeCondition": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "RequireLoginQuestionPathNodeFlowViewModelValidationError"
          }
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "errorMessage"
            }
          }]
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "DateQuestionPathNodeFlowViewModel"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "DateQuestionPathNodeFlowViewModel"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "dateValue"
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "InputTextQuestionPathNodeFlowViewModel"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "InputTextQuestionPathNodeFlowViewModel"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "inputTextRenderingStyle"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "inputTextValue"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "validations"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "InlineFragment",
            "typeCondition": {
              "kind": "NamedType",
              "name": {
                "kind": "Name",
                "value": "InputTextPathQuestionSchemaLengthValidationViewModel"
              }
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "maximumLength"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "minimumLength"
                }
              }]
            }
          }, {
            "kind": "InlineFragment",
            "typeCondition": {
              "kind": "NamedType",
              "name": {
                "kind": "Name",
                "value": "InputTextPathQuestionSchemaRegexValidationViewModel"
              }
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "errorMessage"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "regex"
                }
              }]
            }
          }]
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "inputTextParsedPhoneNumberValue"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "countryCode"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "nationalNumber"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "regionCode"
            }
          }]
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "placeholder"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "FragmentSpread",
            "name": {
              "kind": "Name",
              "value": "PathTextViewModel"
            }
          }]
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "ListQuestionPathNodeFlowViewModel"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "ListQuestionPathNodeFlowViewModel"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "choices"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "FragmentSpread",
            "name": {
              "kind": "Name",
              "value": "ListQuestionChoicePathNodeFlowViewModel"
            }
          }]
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "listSchemaType"
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "ListQuestionChoicePathNodeFlowViewModel"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "ListQuestionChoicePathNodeFlowViewModel"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "primaryImage"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "FragmentSpread",
            "name": {
              "kind": "Name",
              "value": "PathMediaFile"
            }
          }]
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "selected"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "text"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "FragmentSpread",
            "name": {
              "kind": "Name",
              "value": "PathTextViewModel"
            }
          }]
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "subText"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "FragmentSpread",
            "name": {
              "kind": "Name",
              "value": "PathTextViewModel"
            }
          }]
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "NumericQuestionPathNodeFlowViewModel"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "NumericQuestionPathNodeFlowViewModel"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "numericRenderingStyle"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "InlineFragment",
            "typeCondition": {
              "kind": "NamedType",
              "name": {
                "kind": "Name",
                "value": "GenericNumericRenderingStylePathQuestionPathNodeFlowViewModel"
              }
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "FragmentSpread",
                "name": {
                  "kind": "Name",
                  "value": "GenericNumericRenderingStylePathQuestionPathNodeFlowViewModel"
                }
              }]
            }
          }, {
            "kind": "InlineFragment",
            "typeCondition": {
              "kind": "NamedType",
              "name": {
                "kind": "Name",
                "value": "LengthInInchesNumericRenderingStylePathQuestionPathNodeFlowViewModel"
              }
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "lengthInInches"
                }
              }]
            }
          }, {
            "kind": "InlineFragment",
            "typeCondition": {
              "kind": "NamedType",
              "name": {
                "kind": "Name",
                "value": "StarRatingNumericRenderingStylePathQuestionPathNodeFlowViewModel"
              }
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "maxRating"
                }
              }]
            }
          }]
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "numericValidations"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "InlineFragment",
            "typeCondition": {
              "kind": "NamedType",
              "name": {
                "kind": "Name",
                "value": "InRangeNumericValidationQuestionPathNodeFlowViewModel"
              }
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "max"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "min"
                }
              }]
            }
          }]
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "numericValue"
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "GenericNumericRenderingStylePathQuestionPathNodeFlowViewModel"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "GenericNumericRenderingStylePathQuestionPathNodeFlowViewModel"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "decimalEntry"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "limitToScale"
            }
          }]
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "placeholder"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "FragmentSpread",
            "name": {
              "kind": "Name",
              "value": "PathTextViewModel"
            }
          }]
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "unit"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "FragmentSpread",
            "name": {
              "kind": "Name",
              "value": "PathTextViewModel"
            }
          }]
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "unitPlacement"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "decimalEntry"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "limitToScale"
            }
          }]
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "CreateAccountPathNodeFlowViewModel"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "CreateAccountPathNodeFlowViewModel"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "createAccountError"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "InlineFragment",
            "typeCondition": {
              "kind": "NamedType",
              "name": {
                "kind": "Name",
                "value": "AccountExistsCreateAccountPathNodeFlowViewModelError"
              }
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "errorMessage"
                }
              }]
            }
          }]
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "RedirectPathNodeFlowViewModel"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "RedirectPathNodeFlowViewModel"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "redirectResult"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "FragmentSpread",
            "name": {
              "kind": "Name",
              "value": "RedirectPathNodeFlowViewModelResult"
            }
          }]
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "RedirectPathNodeFlowViewModelResult"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "RedirectPathNodeFlowViewModelResult"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "InlineFragment",
        "typeCondition": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "ApplyFinishRedirectPathNodeFlowViewModelSuccess"
          }
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "application"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                }
              }]
            }
          }]
        }
      }, {
        "kind": "InlineFragment",
        "typeCondition": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "InboxRedirectPathNodeFlowViewModelSuccess"
          }
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "lead"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "conversation"
                },
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "id"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }, {
        "kind": "InlineFragment",
        "typeCondition": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "ReturnToPreviousContextRedirectPathNodeFlowViewModelSuccess"
          }
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "success"
            }
          }]
        }
      }, {
        "kind": "InlineFragment",
        "typeCondition": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "SurveyResponseFinishRedirectPathNodeFlowViewModelSuccess"
          }
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "surveyResponse"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "createdAt"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "surveyName"
                }
              }]
            }
          }]
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "DryRunInfoPathNodeFlowViewModel"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "DryRunInfoPathNodeFlowViewModel"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "sections"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "detailRows"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "key"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "value"
                }
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "summaryText"
            }
          }]
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "ErrorPathNodeFlowViewModel"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "ErrorPathNodeFlowViewModel"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "errorMessage"
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "PathGraphFlowRequestEvent"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "PathGraphFlowRequestEvent"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "InlineFragment",
        "typeCondition": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "EntityCreatedPathGraphFlowRequestEvent"
          }
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "entityCreatedId"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "entityCreatedType"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "nodeReferences"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "FragmentSpread",
                "name": {
                  "kind": "Name",
                  "value": "PathNodeMaterializedReference"
                }
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "createdExpertApplication"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "category"
                },
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "id"
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "slug"
                    }
                  }]
                }
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "createdLead"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "latestRequest"
                },
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "id"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }, {
        "kind": "InlineFragment",
        "typeCondition": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "PathCompletedPathGraphFlowRequestEvent"
          }
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "nodeReferences"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "FragmentSpread",
                "name": {
                  "kind": "Name",
                  "value": "PathNodeMaterializedReference"
                }
              }]
            }
          }]
        }
      }]
    }
  }, {
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "NavigatePathGraphFlowError"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "NavigatePathGraphFlowError"
      }
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "InlineFragment",
        "typeCondition": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "AlreadyCompletedNavigatePathGraphFlowError"
          }
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "errorMessage"
            }
          }]
        }
      }, {
        "kind": "InlineFragment",
        "typeCondition": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "ErrorMessage"
          }
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "errorMessage"
            }
          }]
        }
      }]
    }
  }]
};
/**
 * __useSubmitPathNodeFlowMutation__
 *
 * To run a mutation, you first call `useSubmitPathNodeFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPathNodeFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitPathNodeFlowMutation, { data, loading, error }] = useSubmitPathNodeFlowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */

function useSubmitPathNodeFlowMutation(baseOptions) {
  return useMutation(SubmitPathNodeFlowDocument, baseOptions);
}

export { SubmitPathNodeFlowDocument, useSubmitPathNodeFlowMutation };
//# sourceMappingURL=SubmitPathNodeFlow.generated.js.map
